import React, { useState } from 'react';
import { Button, Form, FormField, FormFieldLabel, Input } from '../../ui'
import './style.css';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import {
  selectCustomer,
  setBookingSearchId, setBookingSearchUserInput, setSearchType
} from '../../redux/slices/customer-slice';
import { Navigate } from 'react-router-dom';
import { fetchBookingDataBySearch } from "../../redux/slices/customer-bookings";
import { resetErrorDialog, selectNotificationStore } from '../../redux/slices/notification-slice';

export default function SearchBookingForm() {
  const dispatch = useAppDispatch();
  const customer = useAppSelector(selectCustomer());
  const notification = useAppSelector(selectNotificationStore());

  const [bookingValue, setBookingValue] = useState('');
  const [userValue, setUserValue] = useState('');

  const handleChangeId = (e: any) => {
    dispatch(resetErrorDialog());
    const bookingIdValue = e.target.value;
    setBookingValue(bookingIdValue)
    dispatch(setBookingSearchId(bookingIdValue));
  }

  const handleChangeUserInput = (e: any) => {
    dispatch(resetErrorDialog());
    const userInputValue = e.target.value;
    setUserValue(userInputValue)
    dispatch(setBookingSearchUserInput(userInputValue));
  }

  const navigateToDetails = (e: any) => {
    e.preventDefault()
    dispatch(setSearchType({ type: 'BOOKING' }));
    dispatch(fetchBookingDataBySearch(true))
  };

  return (
    <Form floatingLabel testId="searchForm">
      <p>Search for Booking</p>
      <FormField
        labelForId="test-form-input"
        labelText="Booking Information"
        type="input"
        testId='testInputText'
      >
        <div className='form-field-container'>
          <Input
            className="booking-id-search"
            value={bookingValue}
            id="test-booking-id-input"
            testId='testBookingIdField'
            placeholder="EMG Booking ID"
            noBackground
            onChange={handleChangeId}
          />
          <Input
            className='user-input-search'
            value={userValue}
            id="test-booking-userInput-input"
            testId='testBookingInputField'
            placeholder="Email or Last Name"
            noBackground
            onChange={handleChangeUserInput}
          />
        </div>
      </FormField>
      <FormField
        style={{ paddingTop: '7px' }}
        type="input"
      >
        <Button
          onClick={navigateToDetails}
          key="applyFilters"
          testId='testApplyFiltersBtn'
        >
          Search
        </Button>
      </FormField >

      {notification?.errorDialog?.code === 'MISSING_BOOKING_SEARCH_FIELD' && <FormFieldLabel testId="noBooking" className='Error'>Booking search not possible, enter valid ID and Email/Last Name.</FormFieldLabel>}
      {notification?.errorDialog?.code === 'BOOKING_NOT_FOUND' && <FormFieldLabel testId="noBooking" className='Error'>Booking not found for this ID and Email/Name.</FormFieldLabel>}
      {notification?.errorDialog?.code === 'FORBIDDEN_BOOKING' && (
        <FormFieldLabel testId="forbiddenLabel" className='Error'>
          Access forbidden.
        </FormFieldLabel>
      )}
      {customer.id && customer.search.type === 'BOOKING' && <Navigate to={`/customers/${customer.id}?tab=booking-history&bookingId=${customer.search.identifier.bookingId}&userInput=${customer.search.identifier.userInput}`} replace={true} />}
    </Form>
  )
}
